import React from 'react'
import { ReactComponent as CampaignIcon } from '../../../images/sold_vehicle_path/campaign_name_icon.svg'
import { ReactComponent as ChevronRight } from '../../../images/icons/chevron_right.svg'

import dayjs from 'dayjs'
import { useNavigate } from 'react-router'
import { useDealership } from '../../../store/zustand/dealershipStore'
import { useTranslation } from 'react-i18next'
import { useGetDisplayCampaignById } from '../../../api/dealership/campaigns/useGetDisplayCampaignById'

type VehicleMarketedStepProps = {
  date: Date
  client_campaign_id?: string
  client_campaign_display_name?: string
  first_imp?: string
  last_imp?: string
  impressions?: number
  clicks?: number
}

export default function VehicleMarketedStep({
  path,
}: {
  path: VehicleMarketedStepProps
}): JSX.Element {
  const navigate = useNavigate()
  const dealership = useDealership()
  const { t } = useTranslation('routes')
  const { data: campaign } = useGetDisplayCampaignById({
    campaign_id: path.client_campaign_id,
  })
  return (
    <div
      className={'bg-primary-xiketic p-4 rounded-2xl min-w-60 h-fit flex flex-col gap-3'}>
      <div className={'flex flex-1 flex-col gap-1 items-center'}>
        <span className="text-md font-bold text-white">Vehicle Marketed</span>
        <span className="text-xs font-bold text-gainsboro-gray/70">
          {dayjs(path?.first_imp).format('M/D/YY')} -{' '}
          {dayjs(path?.last_imp).format('M/D/YY')}
        </span>
      </div>
      <button
        onClick={(e) => {
          e.preventDefault()
          navigate(
            t('dealership.campaigns.report', {
              dealership,
              campaign: {
                client_campaign_id: path?.client_campaign_id,
                product_code: campaign?.product_code,
                start_date: dayjs(path?.first_imp).format('YYYY-MM-DD'),
                end_date: dayjs(path?.last_imp).format('YYYY-MM-DD'),
              },
            }),
          )
        }}
        className={
          'bg-primary-independence justify-between text-white font-bold text-xs rounded-sm p-2 flex flex-row gap-2 items-center'
        }>
        <div className="flex flex-row gap-2 items-center">
          <CampaignIcon />
          {path?.client_campaign_display_name}
        </div>
        <ChevronRight fill={'white'} />
      </button>

      <div className="flex flex-row justify-between font-bold items-center">
        <div className="flex flex-row gap-2 items-center">
          <div className="w-5 h-5 rounded-full bg-gradient-to-b from-light-green to-vivid-sky-blue" />
          <span className="text-white text-xs">Impressions</span>
        </div>
        <span className="text-white text-xs">{path?.impressions}</span>
      </div>
      <div className="flex flex-row justify-between font-bold items-center">
        <div className="flex flex-row gap-2 items-center">
          <div className="w-5 h-5 rounded-full bg-gradient-to-b from-melon to-cyclamen" />
          <span className="text-white text-xs">Clicks</span>
        </div>
        <span className="text-white text-xs">{path?.clicks}</span>
      </div>

      {/* <span className="text-white font-bold text-xs">
        Vehicle first seen on {dayjs(path?.date).format('M/D/YY')}
      </span> */}
    </div>
  )
}
